module.exports = "/images/giving.svg?05fef8fc0c9838c12ebf531754a13955";